import React from 'react';

import './styles.scss';

export const InlineDivider = ({ className = '' }) => <span className={`inline-divider ${className}`} />;

export default InlineDivider;
